import { PublicRoutes } from '@/constants/routes'
import { webApiService } from '@/services'
import { setConfig } from '@/store/config'
import { useAppDispatch } from '@/store/store'
import { Progress } from '@nextui-org/react'
import { useEffect, useState } from 'react'
import { Navigate, Outlet, useLocation, useNavigate, useParams } from 'react-router-dom'

const LoadSeller = () => {
  console.log('LoadSeller LoadSeller LoadSeller')
  const { slug } = useParams<{ slug: string }>()
  console.log('🚀 ~ LoadSeller ~ slug:', slug)
  const dispatch = useAppDispatch()
  const [data, setData] = useState({ config: null, loading: true })
  const navigate = useNavigate()
  const location = useLocation()

  const loadConfigSeller = async () => {
    const configSeller = await webApiService.getConfigBySlug(String(slug)).then(res => res.data)
    console.log('🚀 ~ loadConfigSeller ~ configSeller:', configSeller)
    dispatch(setConfig({ loading: false, config: configSeller }))
    setData({ loading: false, config: configSeller })
  }

  useEffect(() => {
    if (!slug) {
      navigate(PublicRoutes.NOTFOUND, { replace: true })
      return
    }

    const normalizedSlug = slug.toLowerCase()

    if (slug !== normalizedSlug) {
      const newPath = location.pathname.replace(
        `/${slug}`,
        `/${normalizedSlug}`
      )

      navigate(newPath + location.search, { replace: true })
      return
    }

    loadConfigSeller()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug])

  if (data.loading) {
    return (
      <Progress
        color='default'
        size='sm'
        isIndeterminate
        aria-label='Loading...'
        className='w-full'
      />
    )
  }

  if (data.config === null && !data.loading) return <Navigate to={PublicRoutes.NOTFOUND} />

  return (
    <Outlet />
  )
}

export default LoadSeller
